// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"623de86b","787":"bc16e069"}[chunkId] + ".chunk.js";
};